export default "__VITE_ASSET__CmuxfWsQ__"